import { createFeatureSelector, createSelector } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import { IReport } from '../../report/IReport';
import { Process } from '../../shared';
import { Category } from '../../shared/category/category.model';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { IUserColor } from '../IUserColor';
import { IUserInfo } from '../IUserInfo';
import { UserActionsUnion, UserActionTypes } from './user.actions';
import { IUser } from '../IUser';
export const userFeatureKey = 'user';
export interface IUserAccess {
    UserProcessCategories: Array<Category>;
    UserProcessesMain: Array<Process>;
    UserReportsMain: Array<IReport>;
}

const log = new LoggingService();

export interface State extends IUserAccess {
    givenName: string | undefined;
    familyName: string | undefined;
    userInfo: IUserInfo;
    UserWebColors: Array<IUserColor>;
}

export const initialState: State = {
    UserProcessCategories: [],
    UserProcessesMain: [],
    UserReportsMain: [],
    givenName: undefined as any,
    familyName: undefined as any,
    userInfo: {
        MaxNbrofReports: environment.defaultMaxReports
    } as IUserInfo,
    UserWebColors: []
};

function parseName(employeeName: string) {
    const parts = employeeName.split(',');
    return {
        givenName: parts[1],
        familyName: parts[0]
    };
}

export function reducer(
    state: State = initialState,
    action: UserActionsUnion
): State {
    let name = {
        familyName: undefined as any,
        givenName: undefined as any
    };
    switch (action.type) {
        case UserActionTypes.SetUserPermissions:
            log.debug({
                type: 'UserInfoReducer:SetUserPermissions',
                payload: action.payload
            });
            try {
                name = parseName(
                    action.payload.UserReportsMain[0].EmployeeName
                );
            } catch (e) {
                // nothing
            }
            return {
                ...state,
                ...action.payload,
                givenName: name.givenName,
                familyName: name.familyName
            };
        case UserActionTypes.SetUserInfo:
            const showSignaturePolicyFromSession =
                state.userInfo.ShowSignaturePolicy === false
                    ? false
                    : action.payload.ShowSignaturePolicy ?? true;
            return {
                ...state,
                userInfo: {
                    ...action.payload,
                    MaxNbrofReports:
                        action.payload.MaxNbrofReports ||
                        state.userInfo.MaxNbrofReports,
                    ShowSignaturePolicy: showSignaturePolicyFromSession,
                    LastInvoiceEnd: new Date(
                        action.payload.LastInvoiceEnd as any
                    ),
                    LastInvoiceStart: new Date(
                        action.payload.LastInvoiceStart as any
                    )
                }
            };
        case UserActionTypes.SetUserColors:
            return {
                ...state,
                UserWebColors: [...action.payload]
            };
        case UserActionTypes.SetSignaturePolicy:
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    ShowSignaturePolicy: action.payload.ShowSignaturePolicy
                }
            };
        default:
            return state;
    }
}
const userState = createFeatureSelector<State>('user');
export const getUserProcessCategories = createSelector(
    userState,
    x => x.UserProcessCategories
);
export const getUserProcessesMain = createSelector(
    userState,
    x => x.UserProcessesMain
);
// export const getUserReportsMain = (state: State) => state.UserReportsMain;
// export const getUserRememberMe = (state: State) => state.rememberMe;
export const getUserInfo = createSelector(userState, x => x.userInfo);
export const getUser = createSelector(userState, x => x as IUser);
// TODO: map to new userInfo property when API is updated
export const getSuperuserEnabled = createSelector(
    userState,
    x => x.userInfo.IsSuperUser
);
export const getUserColors = createSelector(userState, x => x.UserWebColors);
export const getUserColorsSorted = createSelector(getUserColors, x =>
    [...x].sort((a, b) => a.StatusID - b.StatusID)
);
export const getMaxReports = createSelector(
    userState,
    x => x.userInfo.MaxNbrofReports
);
export const getUserProcesses = createSelector(
    userState,
    x =>
        x.UserProcessCategories.reduce(
            (a, c) => a.concat(c.UserProcesses),
            [] as Process[]
        ) as Process[]
);
export const getProcessByName = createSelector(
    getUserProcesses,
    (x: Process[], props: { ProcessName: string }) =>
        x.find(y => y.ProcessName === props.ProcessName)
);

export const getUserProcessesMainByName = createSelector(
    getUserProcessesMain,
    (x: Process[], props: { ProcessName: string }) =>
        x.find(y => y.ProcessName === props.ProcessName)
);
